import React, {useState} from 'react';

export default function BlogPublishing({resource, redReviewEnabled, onRequestReview, onAnnounce}) {
    const [preamble, setPreamble] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const reviewStatus = resource.redContentReview?.status || 'draft';
    const didAnnounce = Boolean(resource.metadata?.didAnnounce);
    const canAnnounce = resource.isPublished && resource.requiredSubscriptionId && !didAnnounce
        && (!redReviewEnabled || reviewStatus === 'approved');

    const run = async action => {
        setBusy(true);
        setError('');
        try {
            await action();
        } catch (nextError) {
            setError(nextError.message);
        } finally {
            setBusy(false);
        }
    };

    return <section className="content-editor-panel" aria-labelledby="blog-publishing-title">
        <h2 id="blog-publishing-title">Blog workflow</h2>
        <dl className="content-publication-details">
            <div><dt>Published</dt><dd>{resource.publishedAt
                ? new Date(resource.publishedAt).toLocaleString()
                : 'Not published'}</dd></div>
            {redReviewEnabled && <div><dt>Mayhem RED review</dt><dd>{reviewStatus}</dd></div>}
            <div><dt>Subscriber announcement</dt><dd>{didAnnounce ? 'Sent' : 'Not sent'}</dd></div>
        </dl>
        {error && <p className="flash error" role="alert">{error}</p>}
        {redReviewEnabled && reviewStatus !== 'approved' && <button type="button"
            className="button secondary" disabled={busy}
            onClick={() => run(onRequestReview)}>Request Mayhem RED review</button>}
        <label htmlFor="blog-announcement-preamble">Announcement message</label>
        <textarea id="blog-announcement-preamble" rows="3" value={preamble}
            onChange={event => setPreamble(event.target.value)} />
        <button type="button" className="button" disabled={busy || !canAnnounce}
            onClick={() => {
                if (!window.confirm('Send this announcement to eligible subscribers now?')) return;
                run(() => onAnnounce(preamble));
            }}>{didAnnounce ? 'Announcement sent' : 'Announce to subscribers'}</button>
        {!canAnnounce && !didAnnounce && <p className="help">
            Publish the post, require a subscription, and complete any RED review before announcing.
        </p>}
    </section>;
}
